import React, { createContext, useCallback } from 'react'
import { useAsyncResource, resourceCache } from 'use-async-resource'
import { Auth } from 'src/api'

// Verifica se o token existe no navegador
const fetchVerifyToken = async () => await Auth.verifyToken()

export const AuthContext = createContext()

const AppContext = ({ children }) => {
  const [DataSign, GetDataSign] = useAsyncResource(fetchVerifyToken, [])

  const Sign = DataSign()

  // Verifica se o token ainda existe no navegador
  const SignVerify = useCallback(() => {
    // 🧹 clear the cache so we can make a new api call
    resourceCache(fetchVerifyToken).clear()
    // 🙌 refresh the data reader
    GetDataSign()
  }, [GetDataSign])

  return (
    <AuthContext.Provider
      value={{
        Sign,
        SignVerify,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AppContext
